export const DIGITIZATION_STORAGE_TRANSFER_STATUSES = {
  notStarted: 'not_started',
  inProgress: 'in_progress',
  complete: 'complete'
};

export const DIGITIZATION_FILE_TYPES = {
  videos: {
    type: 'video',
    isStreamable: true
  },
  audios: {
    type: 'audio',
    isStreamable: true
  },
  photos: {
    type: 'photo'
  }
};

export const DIGITIZATION_APP_STATE_KEYS = {
  projectTransferToStorageComplete: 'project_transfer_to_storage_complete'
};

export const DIGI_CENTER_NON_OWNER_NAME = 'Shared Digitization Project';
export const DIGITIZATION_FILES_STORE_ID = 'digitization-files-store';
export const DIGITIZATION_STATUS_CHECK_INTERVAL = 5_000; //milliseconds
export const DIGITIZATION_PROJECT_GRACE_PERIOD = 10; //days
export const DIGITIZATION_PROJECT_EXPIRY_PERIOD = 90; // days
